export type FileType = undefined | 'image' | 'video' | 'audio' | 'document' | 'pdf';

export const getFileTypeByName = (name: string): FileType => {
  const ext = name.split('.').pop()?.toLowerCase();

  if (!ext) {
    return undefined;
  }

  if (['webp', 'png', 'jpg', 'jpeg', 'svg', 'gif'].includes(ext)) {
    return 'image';
  }

  if (['mp4', 'avi', 'mkv', 'mov', 'wmv'].includes(ext)) {
    return 'video';
  }

  if (['mp3', 'wav', 'ogg', 'aac'].includes(ext)) {
    return 'audio';
  }

  if (['doc', 'docx', 'txt', 'rtf'].includes(ext)) {
    return 'document';
  }

  if (ext === 'pdf') {
    return 'pdf';
  }

  return undefined;
};
